import { ThirdPartyDetailsForm } from "./Form";
import useThirdPartyDetails from "./hooks/useThirdPartyDetails";

export const ThirdPartyDetails = () => {
  const props = useThirdPartyDetails();
  return <ThirdPartyDetailsForm {...props} />;
};

export default ThirdPartyDetails;
